import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchSatisfiedCounter,
  fetchSatisfiedCounterSuccess,
  fetchSatisfiedCounterFailure,
} from "../slices/satisfiedCounter";

function* fetchSatisfiedCounterSaga() {
  try {
    const response = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/v1/counters/satisfied-customers`,
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const result = yield response.json();

    yield put(fetchSatisfiedCounterSuccess(result)); // ✅ raw data only
  } catch (error) {
    yield put(fetchSatisfiedCounterFailure(error.message));
  }
}

export function* watchSatisfiedCounter() {
  yield takeLatest(fetchSatisfiedCounter.type, fetchSatisfiedCounterSaga);
}
